import { render, staticRenderFns } from "./AirPollutionLimits.vue?vue&type=template&id=5e728c49&scoped=true"
import script from "./AirPollutionLimits.vue?vue&type=script&lang=js"
export * from "./AirPollutionLimits.vue?vue&type=script&lang=js"
import style0 from "./AirPollutionLimits.vue?vue&type=style&index=0&id=5e728c49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e728c49",
  null
  
)

export default component.exports